export enum NavBarMenuListType {
    dropDown = "dropDown",
    popOver = "popOver"
}
